import { fetchCourses } from "PlatForms/OrgLMS/Services/MentorServices/LibraryService";
import { useEffect, useState } from "react";

export const useLibrary = () => {
  const mentorId = localStorage.getItem("personalId");
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    getCourses();
  }, []);

  const getCourses = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await fetchCourses(mentorId);
      setCourses(data || []);
    } catch (err) {
      // Fail gracefully instead of crashing the page (e.g. 404 when the
      // mentor record isn't set up yet). Show an empty state.
      console.error("Failed to load library courses:", err);
      setError(err?.response?.data?.message || err?.message || "Failed to load library courses");
      setCourses([]);
    } finally {
      setLoading(false);
    }
  };

  return {
    courses,
    loading,
    error,
  };
};
